import { render, staticRenderFns } from "./config-backup-restore.vue?vue&type=template&id=198699e6"
import script from "./config-backup-restore.vue?vue&type=script&lang=js"
export * from "./config-backup-restore.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports